import { makeStyles } from '@material-ui/core/styles';
import { isiOS } from '../../../utils/utility';
import { fontClasses } from '../../../fontStyles';

const makeStyle = makeStyles((theme) => ({
    container: {
        overflowY: 'auto',
        overflowX: 'hidden',
        // width: '100% !important',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: `${theme.palette.primary.background}`,
        padding: '20px 20px 24px',
        marginTop: isiOS() ? 'calc(64px + env(safe-area-inset-top))' : '64px',
        height: isiOS() ? 'calc(100vh - 64px - env(safe-area-inset-top))' : 'calc(100vh - 64px)',
        justifyContent: 'space-between',
    },
    body: {
        display: 'flex',
        flexDirection: 'column',
        flex: '1 1 auto',
        overflowY: 'auto',
    },
    imageWrapper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '16px 0 28px 0',
    },
    title: {
        ...fontClasses.title2,
        color: `${theme.palette.tertiary.headingText} !important`,
        textAlign: 'center',
        marginTop: '8px',
    },
    
    subtitle: {
        ...fontClasses.body1,
        color: `${theme.palette.tertiary.headingText} !important`,
        textAlign: 'center',
        marginTop: '8px',
    },
    numberedList: {
        ...fontClasses.body1,
        color: `${theme.palette.tertiary.headingText}`,
        paddingLeft: '24px',
        margin: '8px auto 0 auto',
        listStyleType: 'decimal',
        listStylePosition: 'outside',
        '& li': {
            marginTop: '8px',
            display: 'list-item',
            listStyleType: 'auto !important',
        },      
    },
    numberedListNone:{
       '& li': {
            listStyleType: 'none !important',
        }, 
    },
    IQAirDisplayBox: {
       display:'flex',
       flexDirection:'column',
        marginTop: '16px',
        padding:'0 16px',
       
        '& $numberedList': {
             margin: '2px auto 12px auto',
             '& li:last-child': {
            marginTop: '0px',
            display: 'list-item',
            listStyleType: 'none !important',
        },
        }
    },
    buttonContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        paddingTop: '16px',
        '& .MuiButton-root': {
            WebkitTapHighlightColor: 'transparent',
            '&:focus': {
                backgroundColor: 'inherit',
            },
            '& .MuiTouchRipple-root': {
                display: 'none',
            },
        },
    },
    primaryButton: {
        backgroundColor: `${theme.palette.tertiary.provisionEnableButton} !important`,
        color: '#fff !important',
        textAlign: 'center',
        width: '100%',
        padding: '14px',
        textTransform: 'none',
        borderRadius: '8px',
        ...fontClasses.body1,
        fontWeight: '500',
        fontSize: '16px !important',
    
        '&:disabled': {
            backgroundColor: `${theme.palette.tertiary.disableApplyButtonBg} !important`,
            borderColor: `${theme.palette.tertiary.disableApplyButtonBg} !important`,
            color: `${theme.palette.tertiary.disableApplyButtonText} !important`,
            opacity: 1,
        '& span':{
         color: `${theme.palette.tertiary.disableApplyButtonText} !important`,
        }   
        },
    },
    iqAirDisplayPrimaryButton:{
        backgroundColor:'transparent !important',
        border:'1px solid #01B5DE !important',
        color:'#01B5DE !important',
    },
    secondaryButton: {
        color: `${theme.palette.tertiary.provisionEnableButton}`,
        textAlign: 'center',
        width: '100%',
        padding: '14px',
        textTransform: 'none',
        borderRadius: '8px',
        border: `1px solid ${theme.palette.tertiary.provisionEnableButton}`,
        backgroundColor: 'transparent',
        ...fontClasses.body1,
        fontSize: '16px !important',
        fontWeight: '500',
    },
    textButton: {
        color: `${theme.palette.tertiary.provisionEnableButton}`,
        textAlign: 'center',
        width: '100%',
        padding: '14px',
        textTransform: 'none',
        borderRadius: '8px',
        background: 'transparent',
        ...fontClasses.body1,
        fontWeight: '700',
    },
    yesNoRow: {
        display: 'flex',
        gap: '12px',
        width: '100%',
    },
    yesNoButton: {
        flex: 1,
        padding: '14px',
        textTransform: 'none',
        borderRadius: '8px',
        border: `1px solid ${theme.palette.tertiary.provisionEnableButton}`,
        backgroundColor: 'transparent',
        color: `${theme.palette.tertiary.provisionEnableButton}`,
        ...fontClasses.body1,
        fontWeight: '500',
        fontSize: '16px !important',
    },
    yesButton: {
        flex: 1,
        padding: '14px',
        textTransform: 'none',
        borderRadius: '8px',
        backgroundColor: `${theme.palette.tertiary.provisionEnableButton} !important`,
        color: '#fff !important',
        ...fontClasses.body1,
        fontWeight: '700',
        fontSize: '16px !important',
    },
    // Take photo screen
    photoHintBox: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: `${theme.palette.primary.cardBackground}`,
        borderRadius: '8px',
        padding: '16px',
        marginTop: '12px',
        gap: '8px',
    },
    photoHintText: {
        ...fontClasses.body2,
        color: `${theme.palette.tertiary.headingText} !important`,
        flex: 1,
        fontWeight:400,
    },
    takePhotoBtn: {
        color: `${theme.palette.tertiary.provisionEnableButton} !important`,
        border: `1px solid ${theme.palette.tertiary.provisionEnableButton} !important`,
        borderRadius: '6px',
        padding: '6px 10px',
        textTransform: 'none',
        whiteSpace: 'nowrap',
        ...fontClasses.body2,
        fontWeight: '700',
        backgroundColor: 'transparent !important',
        flexShrink: 0,
        '&:hover': {
            backgroundColor: 'transparent !important',
        },
    },
    capturedThumb: {
        marginTop: '18px',
        borderRadius: '8px',
        position: 'relative',
        padding: '10px',
        border: `1px solid ${theme.palette.tertiary.provisionEnableButton}`,
    },
    capturedThumbRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '6px 8px',
        backgroundColor: `${theme.palette.primary.background}`,
    },
    capturedThumbName: {
        ...fontClasses.body2,
        color: `${theme.palette.tertiary.headingText}`,
    },
    capturedThumbImg: {
        maxWidth: '100%',
        maxHeight: '50vh',
        width: 'auto',
        height: 'auto',
        display: 'block',
        margin: '0 auto',
    },
    closeThumbBtn: {
        padding: '2px',
        minWidth: 'unset',
        color: `${theme.palette.tertiary.headingText}`,
    },
    // Captured photo full display (used in terminals / connect wires screens)
    capturedPhotoFull: {
        maxWidth: '100%',
        maxHeight: '50vh',
        width: 'auto',
        height: 'auto',
        objectFit: 'contain',
        borderRadius: '8px',
        display: 'block',
        margin: '0 auto 12px auto',
        padding: '10px',
    },
    // Terminal chips
    chipsSection: {
        marginTop: '12px',
    },
    chipGroupLabel: {
        ...fontClasses.graphLabel2,
        color: `${theme.palette.tertiary.headingText} !important`,
        fontWeight: '700',
        marginBottom: '6px',
        marginTop: '16px',
        textAlign: 'left',

    },
    chipRow: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '8px',
    },
    chip: {
        padding: '6px 14px',
        borderRadius: '20px',
        border: `1px solid ${theme.palette.tertiary.provisionEnableButton}`,
        backgroundColor: 'transparent',
        color: `${theme.palette.tertiary.headingText}`,
        cursor: 'pointer',
        ...fontClasses.body2,
        userSelect: 'none',
    },
    chipSelected: {
        padding: '6px 14px',
        borderRadius: '20px',
        border: `1px solid ${theme.palette.tertiary.provisionEnableButton}`,
        backgroundColor: `${theme.palette.tertiary.provisionEnableButton}`,
        color: '#fff',
        cursor: 'pointer',
        ...fontClasses.body2,
        userSelect: 'none',
    },
    showMoreBtn: {
        color: `${theme.palette.tertiary.provisionEnableButton}`,
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: '8px 0',
        textAlign: 'center',
        width: '100%',
        ...fontClasses.body2,
        fontWeight: '700',
        marginTop: '4px',
    },
    // Wiring map table
    wiringTable: {
        width: '100%',
        marginTop: '12px',
    },
    wiringTableHeader: {
        display: 'flex',
        justifyContent: 'center',
        gap:'24px',
        marginBottom: '16px',
        marginLeft:'10px'
    },
    wiringColLabel: {
        ...fontClasses.body2,
        
        textAlign: 'center',
        color: `${theme.palette.secondary.subHeading} !important`,
    },
    wiringRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '30px',
        marginBottom: '16px',
    },
    wiringChipOld: {
         ...fontClasses.greySmallText,
       
        borderRadius: '18px',
        border: `1.364px solid ${theme.palette.primary.dashedBorderColor || '#ccc'}`,
        backgroundColor: theme.palette.primary.cardBackground,
        color: theme.palette.primary.mainText2,
       
        minWidth: '56px',
        textAlign: 'center',
        lineHeight:'24px'
    },
    wiringArrow: {
        ...fontClasses.body1,
        color: `${theme.palette.tertiary.headingText}`,
        flexShrink: 0,
    },
    wiringArrowDarkColor: {
        '& .wiringArrow svg path, & svg path': {
            fill: '#ffffff',
        },
        '& $wiringChipNew': {
            color: '#ffffff',
        },
    },
    wiringChipNew: {
         ...fontClasses.greySmallText,

        borderRadius: '18px',
        border: `1.364px solid #89E18A`,
        backgroundColor: theme.palette.primary.cardBackground,
        color: '#14C415',
       
        minWidth: '56px',
        textAlign: 'center',
        lineHeight:'24px'
    },
    tapeOff: {
       borderColor: '#f37320',
       color: '#f37320',
    },
    wiringChipTape: {
        padding: '5px 14px',
        borderRadius: '20px',
        border: `1px solid #BABEC3`,
        backgroundColor: 'transparent',
        color: '#BABEC3',
        ...fontClasses.body2,
        fontStyle: 'italic',
        minWidth: '60px',
        textAlign: 'center',
    },
    // Error screens (S3, S4, S5)
    errorContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        flex: '1 1 auto',
        paddingTop: '24px',
    },
    errorIcon: {
        marginBottom: '16px',
    },
    errorTitle: {
        ...fontClasses.title2,
        color: '#E02020',
        textAlign: 'center',
        fontWeight: '700',
        marginBottom: '12px',
    },
    errorBody: {
        ...fontClasses.body1,
        color: `${theme.palette.tertiary.headingText}`,
        textAlign: 'center',
    },
    // LED error steps list
    stepsText: {
        ...fontClasses.body2,
    },
    powerPlate:{
        cursor: 'pointer',
        textdecoration: 'none',
        color: '#01B5DE'
    },
    // Setup complete success image wrapper
    successImageWrapper: {
        position: 'relative',
        display: 'inline-block',
        alignSelf: 'center'
    },
    successBadge: {
        position: 'absolute',
        top: '-6px',
        right: '-6px',
        width: '32px',
        height: '32px',
        borderRadius: '50%',
        backgroundColor: `${theme.palette.tertiary.provisionEnableButton}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        fontSize: '18px',
    },
    // Terminal selection grouped grid
    terminalGroupsGrid: {
        display: 'grid',
        columnGap: '32px',
        gridTemplateColumns: '1fr 1fr',
        
        marginTop: '12px',
    },
    terminalGroupCard: {
        
    },
    terminalGroupCardFull: {
        gridColumn: 'span 2',
    },
    chipCircleRow: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
        background: `${theme.palette.primary.cardBackground}`,
        borderRadius: '4px',
        padding: '10px 4px',

    },
    chipCircleRowGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(5, 1fr)',
        gap: '10px',
        background: `${theme.palette.primary.cardBackground}`,
        borderRadius: '4px',
        padding: '10px 0',
    },
    chipCircleItem: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        cursor: 'pointer',
        userSelect: 'none',
        gap: '4px',
        minWidth: '40px',
    },
    chipCircle: {
        width: '24px',
        height: '24px',
        borderRadius: '50%',
        border: '1.5px solid #d0d0d0',
        backgroundColor: 'transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    chipCircleSelected: {
        width: '24px',
        height: '24px',
        borderRadius: '50%',
        border: `1.5px solid ${theme.palette.tertiary.provisionEnableButton}`,
        backgroundColor: `${theme.palette.tertiary.provisionEnableButton}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    chipCircleCheck: {
        color: '#fff',
        fontSize: '16px',
        fontWeight: '700',
        lineHeight: 0,
        '& path': {
            fill: '#fff',
        },
    },
    chipCircleLabel: {
        ...fontClasses.body2,
        color: `${theme.palette.tertiary.headingText} !important`,
        fontSize: '10px',
        textAlign: 'center',
        maxWidth: '52px',
        lineHeight: '1.2',
    },
}));

export default makeStyle;
